import styled from 'styled-components';
import BottomNavUserNavItem from './components/BottomNavUserNavItem';
import { bottomNavConfig } from 'layouts/interfaces/AppLayout';
import { Colors } from 'basic-ui-lib';
import SelectStoreMobile, { SelectStoreMobileRef } from 'modules/dashboard/screens/Create/components/SelectStoreMobile';
import { useRef } from 'react';

const BottomNav = () => {
  const navigation = [bottomNavConfig.SCREENS, bottomNavConfig.PLAYLISTS, bottomNavConfig.NEWSCREEN, bottomNavConfig.STORES, bottomNavConfig.SETTINGS];
  const selectStoreMobileModal = useRef<SelectStoreMobileRef>(null);

  return (
    <>
      <Container>
        {navigation?.map((tab, index) => (
          <BottomNavUserNavItem tab={tab} key={index} onOpenSelectStore={() => selectStoreMobileModal.current?.open()} />
        ))}
      </Container>
      <SelectStoreMobile ref={selectStoreMobileModal} />
    </>
  );
};

export default BottomNav;

const Container = styled.nav`
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding-bottom: 20px;
  background: ${Colors.neutral.bg[1]};
  position: sticky;
  bottom: 0;
  box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.1);
  z-index: 100;
`;
